import qs from "qs";

// 외부 스타샵 웹앱 URL을 생성하는 함수
export const getStarShopUrl = ({ contractNumber, customerNumber }) => {
    const envPath = String(process.env.REACT_APP_ENV).trim() === "real" ? "PROD" : "DEV";
    const query = qs.stringify({ contractNumber, customerNumber, type: "smallmid" });

    return `https://krs-common.wjthinkbig.com/star-shop/${envPath}/index.html?${query}`;
};

// full url을 받아서 pathname+search만 반환하는 함수
export const getUrlPathnameAndSearch = (fullUrl) => {
    return parseFullUrl(fullUrl);
};

// full url을 받아서 pathname만 반환하는 함수
export const getUrlPathname = (fullUrl) => {
    return parseFullUrl(fullUrl).split("?")[0];
};

const parseFullUrl = (fullUrl) => {
    try {
        // URL 정보에 orgin 정보가 있는 경우
        const urlObj = new URL(fullUrl);
        return urlObj.pathname + urlObj.search.split("&FROM_CD")[0];
    } catch (error) {
        // URL 정보에 orgin 정보가 없는 경우(catch 문에서 처리하도록 함) ex) "/mystudy/studyPlan"
        // console.error("유효하지 않은 URL ::", error.message);

        const { MENU_TY_CD = null, LINK } = fullUrl || {};

        // APP 인 경우
        if (MENU_TY_CD && MENU_TY_CD === "APP") {
            return LINK;
        }

        // APP 이 아닌경우
        const orgin = window.location.origin || "";
        const urlObj = new URL(orgin + fullUrl);

        return urlObj.pathname + urlObj.search;
    }
};
